/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IWineFinderByZipData } from './wine-finder-by-zip.data';
import { IWineFinderByZipProps } from './wine-finder-by-zip.props.autogenerated';

export interface IWineFinderByZipViewProps extends IWineFinderByZipProps<IWineFinderByZipData> {

}

/**
 *
 * WineFinderByZip component
 * @extends {React.PureComponent<IWineFinderByZipProps<IWineFinderByZipData>>}
 */
class WineFinderByZip extends React.PureComponent<IWineFinderByZipProps<IWineFinderByZipData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default WineFinderByZip;
